function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#4A90E2",
  fillRule: "nonzero",
  d: "M2.25 0A2.261 2.261 0 0 0 0 2.25v10.5A2.261 2.261 0 0 0 2.25 15h18a2.261 2.261 0 0 0 2.25-2.25V2.25A2.261 2.261 0 0 0 20.25 0h-18zm0 1.5h18a.74.74 0 0 1 .75.75v10.5a.74.74 0 0 1-.75.75h-18a.74.74 0 0 1-.75-.75V2.25a.74.74 0 0 1 .75-.75zm5.947 1.752a.75.75 0 0 0-.697.75v6.996a.75.75 0 0 0 1.125.65l6-3.471a.75.75 0 0 0 .006-1.295l-6-3.528a.75.75 0 0 0-.434-.102zM9 5.312l3.762 2.211L9 9.7V5.312zM6 16.5V18h10.5v-1.5H6z"
});

var SvgVideo = function SvgVideo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVideo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/video.365a78b7.svg";
export { ForwardRef as ReactComponent };